import React from "react";
import { MenuItem, TextField } from "@mui/material";
import { formInputSx, themedFormInputSx } from "../common/formFieldStyles";
import { COLORS } from "../../styles/uiConstants";

const DEFAULT_MENU_PROPS = {
  PaperProps: {
    sx: {
      mt: 0.5,
      maxHeight: 360,
      borderRadius: 2,
      border: `1px solid ${COLORS.slate200}`,
      boxShadow: "0 8px 24px rgba(15,23,42,0.12)",
      "& .MuiMenuItem-root": {
        fontSize: "0.85rem",
        py: 1,
        whiteSpace: "normal",
      },
      "& .MuiMenuItem-root.Mui-selected": {
        bgcolor: COLORS.slate100,
      },
    },
  },
};

/**
 * Tüm menülerde kullanılacak standart dropdown (select).
 * palette prop'u verilirse tema rengi uygulanır.
 * options: [ { value, label } ] veya optionValue/optionLabel ile.
 */
export default function FormSelect({
  label,
  value,
  onChange,
  options = [],
  optionValue = "value",
  optionLabel = "label",
  placeholder = "Seçiniz",
  disabled = false,
  size = "small",
  fullWidth = true,
  palette,
  sx = {},
  SelectProps,
  children,
  ...rest
}) {
  const base = palette ? themedFormInputSx(palette) : formInputSx;
  const baseSx = { ...base, ...sx };

  const mergedSelectProps = {
    ...SelectProps,
    MenuProps: {
      ...DEFAULT_MENU_PROPS,
      ...(SelectProps?.MenuProps || {}),
      PaperProps: {
        ...DEFAULT_MENU_PROPS.PaperProps,
        ...(SelectProps?.MenuProps?.PaperProps || {}),
        sx: {
          ...DEFAULT_MENU_PROPS.PaperProps.sx,
          ...(SelectProps?.MenuProps?.PaperProps?.sx || {}),
        },
      },
    },
  };

  if (children != null) {
    return (
      <TextField
        select
        size={size}
        fullWidth={fullWidth}
        label={label}
        value={value ?? ""}
        onChange={(e) => onChange?.(e.target.value)}
        disabled={disabled}
        sx={baseSx}
        SelectProps={mergedSelectProps}
        {...rest}
      >
        {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
        {children}
      </TextField>
    );
  }

  const safeOptions = (Array.isArray(options) ? options : []).filter(Boolean);
  const optionValues = safeOptions.map((opt) =>
    typeof opt === "object" ? opt[optionValue] : opt
  );
  const resolvedValue =
    value != null && value !== "" && optionValues.some((v) => String(v) === String(value))
      ? value
      : "";

  return (
    <TextField
      select
      size={size}
      fullWidth={fullWidth}
      label={label}
      value={resolvedValue}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
      sx={baseSx}
      SelectProps={mergedSelectProps}
      {...rest}
    >
      {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
      {safeOptions.map((opt) => {
        const val = typeof opt === "object" ? opt[optionValue] : opt;
        const lbl = typeof opt === "object" ? (opt[optionLabel] ?? val) : opt;
        return (
          <MenuItem key={String(val)} value={val}>
            {lbl}
          </MenuItem>
        );
      })}
    </TextField>
  );
}
